import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';

const JUSTIFY_ALIGN_CONTENT_KEYS = ['start', 'end', 'center', 'stretch', 'space-around', 'space-between', 'space-evenly'];
const JUSTIFY_ALIGN_ITEM_SELF_KEYS = ['start', 'end', 'center', 'stretch', 'baseline'];
const AUTO_FLOW_KEYS = ['dense', 'row', 'column'];
var script = {
  name: 'PendoGrid',
  props: {
    columns: {
      type: [String, Number, Array],
      default: 1
    },
    rows: {
      type: [String, Number, Array],
      default: 1
    },
    areas: {
      type: Array,
      default: () => []
    },
    tag: {
      type: String,
      default: 'div'
    },
    gap: {
      type: [String, Array, Number],
      default: null
    },
    autoFlow: {
      type: String,
      default: null,
      validator: autoFlow => AUTO_FLOW_KEYS.includes(autoFlow)
    },
    autoRows: {
      type: String,
      default: null
    },
    autoColumns: {
      type: String,
      default: null
    },
    inline: {
      type: Boolean,
      default: false
    },
    justifyContent: {
      type: String,
      default: null,
      validator: justifyContent => JUSTIFY_ALIGN_CONTENT_KEYS.includes(justifyContent)
    },
    justifyItems: {
      type: String,
      default: null,
      validator: justifyItems => JUSTIFY_ALIGN_ITEM_SELF_KEYS.includes(justifyItems)
    },
    justifySelf: {
      type: String,
      default: null,
      validator: justifySelf => JUSTIFY_ALIGN_ITEM_SELF_KEYS.includes(justifySelf)
    },
    alignContent: {
      type: String,
      default: null,
      validator: alignContent => JUSTIFY_ALIGN_CONTENT_KEYS.includes(alignContent)
    },
    alignItems: {
      type: String,
      default: null,
      validator: alignItems => JUSTIFY_ALIGN_ITEM_SELF_KEYS.includes(alignItems)
    },
    alignSelf: {
      type: String,
      default: null,
      validator: alignSelf => JUSTIFY_ALIGN_ITEM_SELF_KEYS.includes(alignSelf)
    }
  },
  computed: {
    gridAttrs() {
      const templateProps = ['gridTemplateColumns', 'gridTemplateRows', 'gridGap'];
      const justifyAlignProps = ['justifyContent', 'justifyItems', 'justifySelf', 'alignContent', 'alignItems', 'alignSelf'];
      const styles = {};
      const classes = [];
      if (this.inline) {
        classes.push('pendo-inline-grid');
      } else {
        classes.push('pendo-grid');
      }
      if (this.autoFlow) {
        classes.push(`pendo-grid-auto-flow-${this.autoFlow}`);
      }
      templateProps.forEach(prop => {
        if (!this[prop]) {
          return;
        }
        const {
          type,
          value
        } = this[prop];
        if (type === 'style') {
          styles[prop] = value;
        } else {
          classes.push(value);
        }
      });
      justifyAlignProps.forEach(prop => {
        if (this[prop]) {
          classes.push(`pendo-grid-${this.kebabCase(prop)}-${this[prop]}`);
        }
      });
      return {
        style: _objectSpread2({
          gridTemplateAreas: this.gridAreas,
          gridAutoRows: this.autoRows,
          gridAutoColumns: this.autoColumns
        }, styles),
        class: classes
      };
    },
    gridTemplateColumns() {
      if (Array.isArray(this.columns)) {
        return {
          type: 'style',
          value: this.columns.reduce(this.convertPropToCss, '')
        };
      }
      if (this.$options.propsData.autoColumns) {
        return null;
      }
      if (Number(this.columns) <= 8) {
        return {
          type: 'class',
          value: `pendo-grid-columns-${this.columns}`
        };
      }
      return {
        type: 'style',
        value: `repeat(${this.columns}, 1fr)`
      };
    },
    gridTemplateRows() {
      if (Array.isArray(this.rows)) {
        return {
          type: 'style',
          value: this.rows.reduce(this.convertPropToCss, '')
        };
      }
      if (this.$options.propsData.autoRows) {
        return null;
      }
      if (Number(this.rows) <= 8) {
        return {
          type: 'class',
          value: `pendo-grid-rows-${this.rows}`
        };
      }
      return {
        type: 'style',
        value: `repeat(${this.rows}, 1fr)`
      };
    },
    gridGap() {
      if (!this.gap) {
        return null;
      }
      if (Array.isArray(this.gap)) {
        const [x, y] = this.gap;
        return {
          type: 'class',
          value: `pendo-grid-gap-${x}-x pendo-grid-gap-${y}-y`
        };
      }
      if (Number(this.gap) <= 64) {
        return {
          type: 'class',
          value: `pendo-grid-gap-${this.gap}`
        };
      }
      return {
        type: 'style',
        value: `${this.gap}px`
      };
    },
    gridAreas() {
      if (!this.areas) {
        return null;
      }
      return this.areas.map(row => {
        return `"${row.join(' ')}"`;
      }).join(' ');
    }
  },
  methods: {
    kebabCase(val) {
      return val.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    },
    convertPropToCss(acum, item) {
      if (typeof item === 'string') {
        return `${acum} ${item}`;
      }
      return `${acum} ${item}px`;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-grid.vue2.js.map
